import { mapState, mapGetters } from 'vuex';
import extra from '@mixins/officialTopup/extra';
export default {
  mixins: [extra],
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      lang: state => state.lang,
      picList: state => state.page.picList,
      gearList: state => state.page.gearList
    }),
    extraTip() {
      return function () {
        return '';
      };
    },
    ...mapGetters(['extraCoinIco', 'subCoinIco', 'productDefaultIco'])
  },
  methods: {
    // 兼容 v1有CP_PRODUCT_EXT.CONTENT v2无CP_PRODUCT_EXT.CONTENT
    getProductDetail(product) {
      if (product?.CP_PRODUCT_EXT?.CONTENT?.length) {
        let detailList = product?.CP_PRODUCT_EXT?.CONTENT.map(item => {
          return item.NAME + `*${item.COUNT}`;
        });
        let amountLevelExtra = product?.amountLevel?.EXTRA_COIN;
        // 配置了加码图标，并且加码数量大于0，才显示
        if (this.showExtraIcon && +amountLevelExtra > 0) {
          detailList.push(
            `${this.showExtraName}*${amountLevelExtra}(${this.letter.v3ExtraGift})`
          );
        }
        return detailList?.join('、') || '';
      } else {
        return product?.CP_PRODUCT_DESC || '';
      }
    },
    getGiftIcons(item) {
      // 兼容 v1有CP_PRODUCT_EXT.CONTENT
      if (item?.CP_PRODUCT_EXT?.CONTENT?.length) {
        return item?.CP_PRODUCT_EXT.CONTENT.map(gift => {
          return gift.ICON;
        });
      } else if (item?.CP_PRODUCT_ICON) {
        // 兼容 v2有CP_PRODUCT_ICON
        return [item.CP_PRODUCT_ICON];
      } else {
        //v2无CP_PRODUCT_EXT.CONTENT 使用档位配置
        if (this.gearList.length) {
          for (let i = 0; i < this.gearList.length; i++) {
            const gear = this.gearList[i];
            if (+item.TRANS_AMOUNT < +gear.min) {
              return [this.picList?.[`product1`]];
            } else if (+item.TRANS_AMOUNT < +gear.max) {
              return [this.picList?.[`product${i + 1}`]];
            } else if (i === this.gearList.length - 1) {
              return [this.picList?.[`product${this.gearList.length}`]];
            }
          }
          return [];
        } else {
          return [this.picList?.[`product1`]];
        }
      }
    },
    getGiftBanckground(item) {
      if (this.gearList.length) {
        for (let i = 0; i < this.gearList.length; i++) {
          const gear = this.gearList[i];
          if (+item.TRANS_AMOUNT < +gear.min) {
            return this.picList?.[`productbg1`];
          } else if (+item.TRANS_AMOUNT < +gear.max) {
            return this.picList?.[`productbg${i + 1}`];
          } else if (i === this.gearList.length - 1) {
            return this.picList?.[`productbg${this.gearList.length}`];
          }
        }
        return '';
      } else {
        return this.picList?.[`productbg1`];
      }
    },
    getRecommendGiftBanckground() {
      return this.picList?.[`bestproductbg`] || '';
    }
  }
};
